<template>
    <div class="account-menu mb-3">
        <div class="d-none d-lg-block">
            <b-list-group>
                <template v-for="(levelItems, i) in transformedItems">
                    <b-list-group-item
                        :href="levelItems.current.url"
                        :active="i===items.length-1"
                        data-test="root-item"
                        :data-testid="i===items.length-1?'active':''"
                    >
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center flex-grow-1">
                                <slot :name="iconSlot(levelItems.current)" />
                                <div class="col hyphenate">
                                    {{levelItems.current.label}}
                                </div>
                            </div>
                            <button
                                v-if="levelItems.collapsed.length"
                                class="btn btn-light dropdown-toggle float-right"
                                size="sm"
                                v-b-toggle="collapseId(i)"
                                data-test="expand"
                                @click.prevent
                            ></button>
                        </div>
                    </b-list-group-item>
                    <b-collapse v-if="levelItems.collapsed.length" :id="collapseId(i)" data-test="collapsed-items">
                        <template v-for="collapsedItem in levelItems.collapsed">
                            <b-list-group-item class="nested" :href="collapsedItem.url" data-test="child-item">
                                <div class="d-flex align-items-center">
                                    <slot :name="iconSlot(collapsedItem)" />
                                    <div class="col">
                                        {{collapsedItem.label}}
                                    </div>
                                </div>
                            </b-list-group-item>
                        </template>
                    </b-collapse>
                </template>
            </b-list-group>
        </div>


        <div class="d-none d-md-flex d-lg-none flex-wrap mb-n3">
            <template v-for="(levelItems,i) in transformedItems">
                <div class="item mr-2 mb-3 position-relative" :class="{ 'item--selected': i===selected }">
                    <b-dropdown
                        :class="{'dropdown--button-only': !levelItems.collapsed.length }"
                        :variant="levelItems.active?'primary':'light'"
                        :split="!!levelItems.collapsed.length"
                        :split-href="levelItems.current.url"
                        @show="!levelItems.collapsed.length && goto(levelItems.current.url)"
                        @hidden="handleDropdownHidden(i)"
                        ref="dropdown"
                    >
                        <template v-slot:button-content>
                            <span data-test="root-item" :data-testid="levelItems.active?'active':''">
                                <span class="d-inline-block mr-1" style="height: 20px">
                                    <slot :name="iconSlot(levelItems.current)" />
                                </span>
                                <span class="align-middle">
                                    {{levelItems.current.label}}
                                </span>
                            </span>
                        </template>
                        <template v-for="collapsedItem in levelItems.collapsed">
                            <b-dropdown-item
                                :href="collapsedItem.url"
                                :key="collapsedItem.url"
                                data-test="child-item"
                            >
                                <span class="mr-1">
                                    <slot :name="iconSlot(collapsedItem)" />
                                </span>
                                {{ collapsedItem.label }}
                            </b-dropdown-item>
                        </template>
                    </b-dropdown>
                </div>
            </template>
        </div>

        <nav class="d-md-none" aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li v-for="{ current, active } in transformedItems" class="breadcrumb-item" :class="active?'active':''">
                    <component :is="active?'span':'a'" :href="!active ? current.url : null" data-test="root-item" :data-testid="active?'active':''">
                        <span class="d-inline-block mr-1" style="width:15px">
                            <slot :name="iconSlot(current)" />
                        </span>
                        <span class="align-middle">
                            {{ current.label }}
                        </span>
                    </component>
                </li>
            </ol>
        </nav>
    </div>
</template>

<script>
    import {
        BDropdown,
        BDropdownItem,
        BListGroup,
        BListGroupItem,
        BCollapse,
        VBToggle,
    } from 'bootstrap-vue';

    export default {
        components: {
            BDropdown,
            BDropdownItem,
            BListGroup,
            BListGroupItem,
            BCollapse,
        },
        props: {
            items: Array
        },
        data() {
            return {
                selected: null
            }
        },
        computed: {
            transformedItems() {
                return this.items.map((levelItems, i, items) => ({
                    current: levelItems.find(item => item.current),
                    collapsed: levelItems.filter(item => !item.current),
                    active: i===items.length-1
                }));
            },
        },
        methods: {
            iconSlot(item) {
                return `icon:${item.key}`;
            },
            collapseId(level) {
                return `navigation-${level}`;
            },
            goto(url) {
                location.href = url;
            },
            handleDropdownHidden(i) {
                if(this.selected !== null && i === this.selected) {
                    this.selected = null;
                }
            }
        },
        directives: {
            'b-toggle': VBToggle,
        }
    }
</script>
